import Highway from '@dogstudio/highway'
import * as bodyScrollLock from 'body-scroll-lock'
import $ from 'jquery'
import LocomotiveScroll from 'locomotive-scroll'
import sanitizeHtml from 'sanitize-html'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'
import UAParser from 'ua-parser-js'
import store from '../../store'
import { qs, qsa } from '../../utils'
const aboutPages = ['leadership', 'impact', 'about', 'faq', 'press']
const productsPages = ['cashout', 'balanceShield', 'wewin', 'express', 'cashBackRewards']

/**
 * @param {string} slug dictates by the data-router-view attribute of the page template
 * @returns {string}
 */
const _getScreenNameBySlug = (slug) => {
  switch (slug) {
    case 'home':
    case 'newHomePage':
      return 'Website EarnIn dotcom - Home Page'
    case 'cashout':
      return 'Website EarnIn dotcom - Cashout Product Page'
    case 'creditMonitoring':
      return 'Website EarnIn dotcom - Credit Monitoring Product Page'
    case 'about':
      return 'Website EarnIn dotcom - About Page'
    case 'impact':
      return 'Website EarnIn dotcom - Impact Page'
    case 'press':
      return 'Website EarnIn dotcom - Press Page'
    case 'career':
      return 'Website EarnIn dotcom - Careers Page'
    case 'blog':
      return 'Website EarnIn dotcom - Main Blog Page'
    case 'privacy':
      return 'Website EarnIn dotcom - Main Privacy Page'
    case 'shortPrivacyNotice':
      return 'Website EarnIn dotcom - Short Privacy Page'
    case 'fullPrivacy':
      return 'Website EarnIn dotcom - Full Privacy Page'
    case 'cookieNotice':
      return 'Website EarnIn dotcom - Cookie Notice Privacy Page'
    case 'terms':
      return 'Website EarnIn dotcom - Main Terms Of Service Page'
    case 'termsOfService':
      return 'Website EarnIn dotcom - General Terms Of Service Page'
    case 'cashOutTerms':
      return 'Website EarnIn dotcom - Cash Out Terms Of Service Page'
    case 'electronicComunications':
      return 'Website EarnIn dotcom - Electronics Communications Agreement Page'
    case 'partnership':
      return 'Website EarnIn dotcom - Employers B2B page'
    case 'publicResponsibility':
      return 'Website EarnIn dotcom - Security Page'
    case 'evolveBankAndTrust':
      return 'Website EarnIn dotcom - Evolve Agreements page'
    case 'nmls':
      return 'Website EarnIn dotcom - Credit Card State License (NMLS) page'
    case 'fti':
      return 'Website EarnIn dotcom - FTI Page'
    default:
      return `Website EarnIn dotcom - ${slug} Page`
  }
}

const removeDashAndCapitalizeAllWords = (str) => {
  return str.replace(/-/g, ' ').toUpperCase()
}

//here we attach all event listeners to control the tooltip
const initTooltip = (tooltipContainer) => {
  const trigger = tooltipContainer.classList.contains('tooltip-trigger')
    ? tooltipContainer
    : tooltipContainer.querySelector('.tooltip-trigger')
  const tooltip = tooltipContainer.querySelector('.tooltip')
  // show tooltip on hover and focus
  tooltipContainer.addEventListener('mouseenter', () => {
    showTooltip(tooltip)
  })
  trigger.addEventListener('focus', () => {
    showTooltip(tooltip)
    var focusable = tooltip.document.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    )
    var lastFocusable = focusable && focusable[focusable.length - 1]
    if (focusable.length > 0) {
      focusable[0].focus()
      lastFocusable.addEventListener('blur', () => {
        hideTooltip(tooltip)
      })
      document.addEventListener('keydown', (ev) => {
        if (ev.key === 'Escape') {
          hideTooltip(tooltip)
        }
      })
    } else {
      trigger.addEventListener('blur', () => {
        hideTooltip(tooltip)
      })
    }
  })

  tooltipContainer.addEventListener('mouseleave', () => {
    hideTooltip(tooltip)
  })
}
function accordion(event) {
  const btn = event.target.closest('[accordion-trigger]')

  const expanded = btn.getAttribute('aria-expanded') === 'true'
  const target = btn.parentNode.nextElementSibling

  btn.setAttribute('aria-expanded', !expanded)
  target.hidden = expanded
}

function showTooltip(tooltip) {
  // do not show if tooltip has been dismissed
  tooltip.style.display = 'block'
  tooltip.removeAttribute('aria-hidden')
}

function hideTooltip(tooltip) {
  tooltip.style.display = 'none'
  tooltip.setAttribute('aria-hidden', 'true')
}

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Download Windows Phone'
  }

  if (/android/i.test(userAgent)) {
    return "<img alt='play' loading='lazy' decoding='async' src='/assets/img/reskin/play.svg' class='tw-w-[25px] tw-h-8'>Download Android"
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "<img src='/assets/img/reskin/apple.svg'>Download iOS"
  }

  return 'Download App'
}

class DefaultRenderer extends Highway.Renderer {
  el
  scroll
  flagEventAdd = 0
  actIndex = 1
  activeElement

  constructor(opts) {
    super(opts)
    this.modalTriggerBind = this.modalTriggerOnClick.bind(this)
    this.webFunnelTriggerBind = this.webFunnelTriggerOnClick.bind(this)
    this.userAgentData = new UAParser(navigator.userAgent).getResult()
  }

  onEnter() {
    //Note(San): this slug acquisition pattern influence the useless DefaultRenderer assignment "thisPageRenderer = DefaultRenderer" in public/src/highway/index.js defeating the purpose of DefaultRenderer
    //to make the DefaultRenderer useful, we should obtain slug from actual url using window object instead and then we can remove the DefaultRenderer assignment
    //TODO: 1) change slug from data-router-view to the url itself for all of the case above, 2) remove the DefaultRenderer assignment in public/src/highway/index.js, 3) remove data-router-view from pages relying on default
    this.screenName = _getScreenNameBySlug(this.properties.slug)
    this.el = this.wrap.lastElementChild
    store.resizeFn = null
    store.scrollFn = null
    if (window.location.href.includes('help-keep-access-to-your-earnings-safe')) {
      let el = document.createElement('script')
      el.id = 'vvid'
      el.src = 'https://www.votervoice.net/Scripts/BA8AAAAAAAA/Plugin.js?app=campaigns&id=104433'
      document.body.appendChild(el)
      let vv = document.createElement('vv:main')
      let container = document.getElementById('container-vvid')
      container && container.appendChild(vv)
    }
  }

  onLeave() {
    const $modalTrigger = qsa('.modal-trigger')
    const $webFunnelTrigger = qsa('.web-funnel-trigger')
    $modalTrigger.forEach(($elem) => {
      $elem.removeEventListener('click', this.modalTriggerBind)
    })
    $webFunnelTrigger.forEach(($elem) => {
      $elem.removeEventListener('click', this.webFunnelTriggerBind)
    })
    var el = document.querySelector('iframe[src*="voter"]')
    el && el.remove()
    var el = document.querySelector('script[src*="voter"]')
    el && el.remove()
    var el = document.getElementById('vvid')
    el && el.remove()
    var el = document.getElementsByTagName('vv:main')[0]
    el && el.remove()

    bodyScrollLock.clearAllBodyScrollLocks()
  }

  onEnterCompleted() {
    if (document.readyState === 'complete') {
      this.init()
    } else {
      window.addEventListener('load', () => this.init())
    }

    if (!Highway.initial) Highway.initial = true
    this.setAdjustLinks()
    this.trackScreen()
  }

  initTooltips() {
    // initiate tooltips
    const tooltips = qsa('.tooltip-wrapper')
    tooltips.forEach((tooltip) => {
      initTooltip(tooltip)
    })
  }

  initAccordions() {
    const accordionComponents = qsa('.accordion')
    accordionComponents.forEach((accordionComponent) => {
      accordionComponent.addEventListener('click', (event) => {
        accordion(event)
      })
    })
  }

  onLeaveCompleted() {
    if (this.scroll) {
      this.scroll.destroy()
    }
    store.dom.doc.classList.remove('has-scrolled')
    store.dom.doc.classList.remove('is-scrolling-down')
    qs('#more-o-about')?.classList?.remove?.('active')
    const prod = qs('#more-o-products')
    if (prod) {
      qs('#more-o-products')?.classList?.remove?.('active')
    }
    store.flags.first = false
    this.removeClickEventHandlers()
  }

  init() {
    store.dom.body.classList.add('loaded')

    this.initScroll()
    this.initGenericSlide()

    if (qs('.custom-select') !== null) this.setCustomSelect()

    this.bindNewMobileMenuModal()
    this.bindNewDesktopMenu()

    this.getOS()
    this.bindScrollButtons()
    this.closeDownload()
    this.addClickEventHandlers()
    this.bindModalTriggers()
    this.setHoversHeader()
    this.initTooltips()
    this.initAccordions()
    if (aboutPages.includes(this.properties.slug))
      setTimeout(
        () => {
          qs('#more-o-about')?.classList?.add?.('active')
        },
        store.flags.first ? 2000 : 0,
      )

    if (productsPages.includes(this.properties.slug))
      setTimeout(
        () => {
          qs('#more-o-products')?.classList?.add?.('active')
        },
        store.flags.first ? 2000 : 0,
      )
  }

  newMobileModal(modalElement, options) {
    modalElement.addEventListener('click', options.onClose)

    document.querySelectorAll('[data-mobile-menu-modal-open]')?.forEach?.((element) => {
      element.addEventListener('click', options.onOpen)
    })

    document.querySelectorAll('[data-mobile-menu-modal-close]')?.forEach?.((element) => {
      element.addEventListener('click', options.onClose)
    })

    document.querySelectorAll('[data-mobile-menu-modal-content]')?.forEach?.((element) => {
      element.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    })
  }

  newMobileMenuAccordion() {
    const accordion = document.querySelector('[data-js=accordion-collapse]')
    const accordionHeadings = Array.from(
      accordion.querySelectorAll('[data-js*=accordion-collapse-heading]'),
    )
    const downloadIosButtonEl = document.querySelector('[data-js=mobile-modal-menu-download-ios]')
    const downloadAndroidButtonEl = document.querySelector(
      '[data-js="mobile-modal-menu-download-android"]',
    )

    const collapseAccordion = ({ heading, icon }) => {
      icon.alt = 'collapsed icon'
      heading.dataset.expanded = false
      heading.setAttribute('aria-expanded', 'false')
    }

    const collapseAll = () => {
      accordionHeadings.forEach((currentHeading) => {
        const icon = currentHeading.querySelector('[data-js^=accordion-collapse-icon]')
        collapseAccordion({ heading: currentHeading, icon })
      })
    }

    const expandAccordion = ({ heading, icon }) => {
      icon.alt = 'expanded icon'
      heading.dataset.expanded = true
      heading.setAttribute('aria-expanded', 'true')
    }

    /**
     *
     * @param {'for-individuals' | 'for-business' | 'who-we-are' | 'impact'} accordionId
     */
    const setDownloadButtonsDataTrack = (accordionId) => {
      const menuTitle = removeDashAndCapitalizeAllWords(accordionId)
      downloadIosButtonEl.dataset.track = `${menuTitle} subnav Download iOS - nav_0125`
      downloadAndroidButtonEl.dataset.track = `${menuTitle} subnav Download Android - nav_0125`
    }

    /**
     *
     * @param {'for-individuals' | 'for-business' | 'who-we-are' | 'impact'} accordionId
     */
    const expand = (accordionId) => {
      const heading = accordionHeadings.find((heading) => heading.id === accordionId)
      const icon = heading.querySelector('[data-js^=accordion-collapse-icon]')
      expandAccordion({ heading, icon })
      setDownloadButtonsDataTrack(accordionId)
    }

    accordionHeadings.forEach((currentHeading, currentIdx) => {
      currentHeading.addEventListener('click', () => {
        const otherHeadings = accordionHeadings.filter((_, idx) => idx !== currentIdx)
        otherHeadings.forEach((otherHeading) => {
          const icon = otherHeading.querySelector('[data-js^=accordion-collapse-icon]')
          collapseAccordion({ heading: otherHeading, icon })
        })

        const icon = currentHeading.querySelector('[data-js^=accordion-collapse-icon]')
        const isExpanded = currentHeading['ariaExpanded'] === 'true'
        isExpanded
          ? collapseAccordion({ heading: currentHeading, icon })
          : expandAccordion({ heading: currentHeading, icon })
      })
    })

    return { collapseAll, expand }
  }

  bindNewDesktopMenu() {
    const menuTriggerEl = Array.from(document.querySelectorAll('[data-menu-trigger]'))
    const submenuEl = document.querySelector('[data-sub-menu]')
    const downloadIosButtonEl = document.querySelector('[data-js=desktop-sub-menu-download-ios]')
    const downloadAndroidButtonEl = document.querySelector(
      '[data-js=desktop-sub-menu-download-android]',
    )

    if (!menuTriggerEl?.length || !submenuEl) return

    const subMenusEl = Array.from(submenuEl.querySelectorAll('[data-sub-menus-for]'))
    const subMenusContainerEl = submenuEl.querySelector('[data-sub-menus-container]')
    let activeMenu = null
    let subMenuIsHovered = false
    let hideTimeout

    const hideSubMenu = () => {
      submenuEl.dataset.subMenu = 'inactive'
      submenuEl.dataset.activeMenuId = null
    }

    /**
     *
     * @param {'for-individuals' | 'for-business' | 'who-we-are' | 'impact' | null} menuId
     */
    const setDownloadButtonsDataTrack = (menuId) => {
      const menuTitle = removeDashAndCapitalizeAllWords(menuId)
      downloadIosButtonEl.dataset.track = `${menuTitle} subnav Download iOS - nav_0125`
      downloadAndroidButtonEl.dataset.track = `${menuTitle} subnav Download Android - nav_0125`
    }

    subMenusContainerEl.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout)
      subMenuIsHovered = true
      activeMenu.dataset.active = 'true'
    })

    subMenusContainerEl.addEventListener('mouseleave', () => {
      subMenuIsHovered = false
      hideTimeout = setTimeout(hideSubMenu, 200)
      activeMenu.dataset.active = 'false'
      activeMenu = null
    })

    menuTriggerEl.forEach((menuTrigger) => {
      menuTrigger.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout)
        const activeMenuTitle = menuTrigger.dataset.menuTitle

        /** @type {'for-individuals' | 'for-business' | 'who-we-are' | 'impact'} */
        const activeMenuId = menuTrigger.dataset.menuId

        // Show the submenu
        submenuEl.dataset.subMenu = 'active'
        submenuEl.dataset.activeMenuId = activeMenuId

        setDownloadButtonsDataTrack(activeMenuId)

        // animate transition between submenus
        subMenusEl.forEach((subMenuEl) => {
          const isActive = subMenuEl.dataset.subMenusFor === activeMenuTitle
          subMenuEl.dataset.active = isActive ? 'true' : 'false'
        })

        //Highlight which menu dropdown is active
        activeMenu = menuTrigger
        activeMenu.dataset.active = 'true'
        //Unhighlight other menu dropdown triggers
        menuTriggerEl
          .filter((menuTrigger) => menuTrigger.dataset.menuTitle !== activeMenuTitle)
          .forEach((trigger) => (trigger.dataset.active = 'false'))
      })

      menuTrigger.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(() => {
          if (!subMenuIsHovered) {
            hideSubMenu()
            // Remove the active menu dropdown highlight
            activeMenu.dataset.active = 'false'
            activeMenu = null
          }
        }, 200)
      })
    })
  }

  bindNewMobileMenuModal() {
    /**
     * @type {HTMLDialogElement | null}
     * @description The modal element for the mobile menu.
     */
    const modalElement = document.querySelector('[data-mobile-menu-modal]')
    if (!modalElement) return

    const accordion = this.newMobileMenuAccordion()

    // Modal options
    const modalOptions = {
      backdrop: 'dynamic',
      backdropClasses: 'tw-bg-gray-900/50 tw-fixed tw-inset-0 tw-z-40',
      onOpen: () => {
        modalElement.showModal()
        accordion.expand('for-individuals')
        modalElement.dataset.open = 'true'
        bodyScrollLock.disableBodyScroll(modalElement)
      },
      onClose: () => {
        if (!modalElement) return
        delete modalElement.dataset.open
        modalElement.close()
        accordion.collapseAll()
        bodyScrollLock.enableBodyScroll(modalElement)
      },
    }

    this.newMobileModal(modalElement, modalOptions)
  }

  setHoversHeader() {
    const $b_prod = qs('#more-o-products')
    const $b_about = qs('#more-o-about')
    const $all_options = qsa('.js-site-link')
    var hover_flag = false

    $b_about?.addEventListener?.('mouseenter', function (event) {
      if ($b_prod && $b_prod.classList.contains('active')) {
        hover_flag = true
        $b_prod.classList.remove('active')
      }
    })
    $b_about?.addEventListener?.('mouseleave', function (event) {
      if (hover_flag) {
        hover_flag = false
        $b_prod && $b_prod.classList.add('active')
      }
    })

    $b_prod &&
      $b_prod.addEventListener('mouseenter', function (event) {
        if ($b_about.classList.contains('active')) {
          hover_flag = true
          $b_about.classList.remove('active')
        }
      })
    $b_prod &&
      $b_prod.addEventListener('mouseleave', function (event) {
        if (hover_flag) {
          hover_flag = false
          $b_about.classList.add('active')
        }
      })

    $all_options?.forEach?.((e) => {
      e.addEventListener('click', function (event) {
        hover_flag = false
      })
    })
  }

  getOS() {
    const downloadApp = document.getElementById('downloadApp')?.innerHTML
    if (!downloadApp) return
    downloadApp = getMobileOperatingSystem()
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    const $osType = qsa('.os-type')

    $osType.forEach(($div) => {
      if (/android/i.test(userAgent)) {
        $div.classList.add('android')
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        $div.classList.add('ios')
      } else {
        $div.classList.add('nn')
      }
    })
  }

  setAdjustLinks() {
    let $adjustDownloadLinks = qsa('.adjust-download-link')
    let adjustLink = this.getAdjustDownloadLink()
    $adjustDownloadLinks.forEach(($elem) => {
      $elem.href = adjustLink
    })
  }

  getAdjustDownloadLink() {
    return 'https://hchm.adj.st?adj_t=4qjxsgq_hw3ciks&adj_campaign=homepage&adj_adgroup=download&adj_creative=variant&adj_fallback=https%3A%2F%2Fwww.earnin.com%2F'
  }

  setCustomSelect(outSelect) {
    const $parent = qs('.custom-select')
    const $selected = qs('.c-s-selected', $parent)
    const $trigger = qs('.c-s-arrow', $parent)
    const $values = qsa('.c-s-value', $parent)
    const scopeThis = this

    if (this.flagEventAdd == 0) {
      $trigger.addEventListener('click', () => {
        $trigger.classList.toggle('active')
        $('.c-s-values').slideToggle()
      })

      $values.forEach((elem) => {
        elem.addEventListener('click', () => {
          if (scopeThis.actIndex != elem.dataset.termtrigger) {
            scopeThis.actIndex = elem.dataset.termtrigger
            $selected.innerHTML = sanitizeHtml(elem.innerHTML)
            $('.c-s-values').slideToggle()
            $trigger.classList.remove('active')
            $values.forEach((v) => v.classList.remove('active'))
            elem.classList.add('active')
            $trigger.removeAttribute('aria-current')
            $('.terms-d-container').slideUp(650)
            $('#' + elem.dataset.termtrigger).slideDown(650, () => {
              scopeThis.scroll.update()
            })
          }
        })
      })

      this.flagEventAdd = 1
    }

    if (outSelect != null)
      if (scopeThis.actIndex != outSelect.dataset.termtrigger) {
        scopeThis.actIndex = outSelect.dataset.termtrigger
        $selected.innerHTML = outSelect.innerHTML
      }
  }

  initGenericSlide() {
    qsa('.generic-slide').forEach((elem) => {
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

      let autoplayObj = {
        autoplay: {
          delay: 4000,
          waitForTransition: true,
          disableOnInteraction: false,
        },
      }
      if (!mediaQuery || mediaQuery.matches) {
        autoplayObj.autoplay = false
      }
      var dots = qs('.generic-slide-dots', elem)
      new Swiper(elem, {
        slidesPerView: 1,
        centeredSlides: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        loop: true,
        speed: 1000,
        ...autoplayObj,
        on: {
          slideChange: function () {
            if (this.pagination.bullets) {
              this.pagination.bullets.forEach((el, index) =>
                el.setAttribute('aria-current', `${index === this.realIndex}`),
              )
            }
          },
        },
        pagination: {
          el: dots,
          clickable: true,
          renderBullet: function (index, className) {
            const pageName = dots.attributes.getNamedItem('page-name')?.value
            const total = this.slides.length - 2
            const ariaLabel = `go to option ${index + 1} out of ${total}`
            const ariaCurrent = index === 0 ? ' aria-current="true" ' : ''
            const tracking = !!pageName
              ? `data-track="Number ${index + 1} - ${pageName}" data-component="button"`
              : ''
            return `
                <button type="button" aria-label="${ariaLabel}" class="${className}">
                    <svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16" ${ariaCurrent} ${tracking}>
                        <circle class="path" cx="9" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF" stroke-opacity="1" stroke-width="1.5px"></circle>
                        <circle cx="8" cy="8" r="3" fill="transparent"></circle>
                    </svg>
                </button>
            `
          },
        },
      })
    })
  }

  initScroll() {
    const $jsScroll = qs('#js-scroll')
    const $downloadFixed = qs('.download-fix')

    if (store.bounds.ww > 1100) {
      this.scroll = new LocomotiveScroll({
        el: $jsScroll,
        smooth: false,
        smoothMobile: false,
      })
    } else {
      this.scroll = new LocomotiveScroll({
        el: $jsScroll,
        smooth: false,
        smoothMobile: true,
      })
    }

    this.scroll.on('scroll', (func) => {
      const scroll = func.scroll.y

      if (store.bounds.scroll > scroll) {
        store.bounds.scrollDirection = 'up'
        store.dom.header.classList.remove('hide')
      } else if (scroll > 100) {
        store.bounds.scrollDirection = 'down'
        store.dom.header.classList.add('hide')
      }
      if (scroll > 42) store.dom.header.classList.add('bg-blue')
      else store.dom.header.classList.remove('bg-blue')

      if (scroll) store.bounds.scroll = scroll

      if (scroll > window.innerHeight) {
        $downloadFixed?.classList?.add?.('show')
      } else {
        $downloadFixed?.classList?.remove?.('show')
      }

      store.scrollFn && store.scrollFn()
    })
  }

  updateScroll() {
    if (this.scroll) this.scroll.update()
  }

  scrollTo({ target, duration, offset = 0 }) {
    if (this.scroll) {
      this.scroll.scrollTo(target, offset, duration)
    }
  }

  onPageChange() {
    setTimeout(() => {
      this.updateScroll()
    }, 2000)
    store.dom.header.classList.remove('hide')
  }

  setHeaderStyle(style) {
    if (style === 'black') {
      store.dom.header.classList.add('black-content')
    } else {
      store.dom.header.classList.remove('black-content')
    }
  }

  bindScrollButtons() {
    qsa('[data-scroll-to]').forEach((button) => {
      button.addEventListener('click', () => {
        this.scrollTo({ target: button.dataset.scrollTo })
        qs(button.dataset.scrollTo) && qs(button.dataset.scrollTo + ' input').focus()
      })
    })
  }

  closeDownload() {
    qs?.('.close-d-f')?.addEventListener?.('click', () => {
      qs('.download-fix').classList.add('hide')
    })
  }

  /**
   * @todo should we log error to data dog or some platform?
   */
  trackEvent(eventName, properties) {
    if (!window?.analytics?.track) {
      console.error('Tracking event failed: segment analytics is not loaded')
      return
    }

    return window.analytics.track(eventName, properties)
  }

  /**
   * @typedef {Object} Properties
   * @property {string|null} elementName
   * @property {string|null} component
   * @property {string} screenName
   * @property {string|null} browserName
   * @property {string|null} browserVersion
   * @property {string|null} osName
   * @property {string|null} deviceModel
   * @property {string|null} deviceVendor
   * @property {string|null} osVersion
   * @property {boolean} isMobile
   * @property {number} viewportHeight
   * @property {number} viewportWidth
   * @property {string} viewportOrientation
   * @property {string} url
   * @property {string} websitePage
   *
   * @param {Properties} properties when provided, it will overrides default properties. Note, it is required to always assign elementName and component.
   * @returns {Properties}
   */
  async trackUserInteractionWithElement(properties = {}) {
    const viewportData = this.getViewportData()

    if (!properties.elementName) {
      throw new Error('properties must have elementName')
    }
    if (!properties.component) {
      throw new Error('properties must have component')
    }

    await this.trackEvent('User interacted with element', {
      screenName: this.screenName,
      browserName: this.userAgentData?.browser?.name ?? null,
      browserVersion: this.userAgentData?.browser?.version ?? null,
      osName: this.userAgentData?.os?.name ?? null,
      deviceModel: this.userAgentData?.device?.model ?? null,
      deviceVendor: this.userAgentData?.device?.vendor ?? null,
      osVersion: this.userAgentData?.os?.version ?? null,
      isMobile: this.userAgentData.device.type === 'mobile',
      viewportHeight: viewportData.height,
      viewportWidth: viewportData.width,
      viewportOrientation: viewportData.orientation,
      url: window.location.href,
      websitePage:
        window.location.pathname.slice(-1) === '/'
          ? window.location.pathname
          : `${window.location.pathname}/`,
      ...properties,
    })
  }

  /**
   * Tracks a click event; be it clicking link, icon, button, and such; sends analytics data to segment.
   *
   * @param {PointerEvent} event - The click event.
   */
  async handleClick(event) {
    const button = event.currentTarget

    const shouldStopPropagation = () => {
      return button.href && this._isNonJavascriptURL(button.href)
    }

    const shouldPreventDefault = () => {
      return (
        button.href &&
        (this._isExternalURL(button.href) || button.getAttribute('data-router-disabled') === '')
      )
    }

    if (shouldStopPropagation()) {
      event.stopImmediatePropagation()
    }

    if (shouldPreventDefault()) {
      event.preventDefault()
      await this.trackUserInteractionWithElement({
        elementName: button.dataset.track,
        component: button.dataset.component,
      })
      if (button.target) return window.open(button.href, button.target)
      return (window.location.href = button.href)
    }

    return this.trackUserInteractionWithElement({
      elementName: button.dataset.track,
      component: button.dataset.component,
    })
  }

  /**
   * @note the third argument of addEventListener, "useCapture", help maintains referential equality so we add and remove the same click event handler callback, please be careful if you change this
   * @see https://stackoverflow.com/questions/10444077/javascript-removeeventlistener-not-working
   */
  addClickEventHandlers() {
    qsa('[data-track]').forEach((element) =>
      element.addEventListener('click', this.handleClick.bind(this), true),
    )
  }

  /**
   * @note the third argument of removeEventListener, "useCapture", help maintains referential equality so we add and remove the same click event handler callback, please be careful if you change this
   * @see https://stackoverflow.com/questions/10444077/javascript-removeeventlistener-not-working
   */
  removeClickEventHandlers() {
    qsa('[data-track]').forEach((element) =>
      element.removeEventListener('click', this.handleClick.bind(this), true),
    )
  }

  getViewportData() {
    const width =
      window?.innerWidth ??
      document?.documentElement?.clientWidth ??
      document?.body?.clientWidth ??
      'unknown'

    const height =
      window?.innerHeight ??
      document?.documentElement?.clientHeight ??
      document?.body?.clientHeight ??
      'unknown'

    const orientationData = window?.screen?.orientation?.type
    let orientation = 'unknown'

    if (orientationData) {
      orientation = orientationData.split('-')[0]
    }

    if (!['landscape', 'portrait'].includes(orientation)) {
      orientation = window?.matchMedia?.('(orientation: portrait)')?.matches
        ? 'portrait'
        : window?.matchMedia?.('(orientation: landscape)')?.matches
        ? 'landscape'
        : 'unknown'
    }

    return { width, height, orientation }
  }

  trackScreen() {
    const viewportData = this.getViewportData()

    this.trackEvent('User viewed screen', {
      browserName: this.userAgentData?.browser?.name ?? null,
      browserVersion: this.userAgentData?.browser?.version ?? null,
      osName: this.userAgentData?.os?.name ?? null,
      screenName: this.screenName,
      deviceModel: this.userAgentData?.device?.model ?? null,
      deviceVendor: this.userAgentData?.device?.vendor ?? null,
      osVersion: this.userAgentData?.os?.version ?? null,
      isMobile: this.userAgentData.device.type === 'mobile',
      viewportHeight: this.getViewportData().height,
      viewportWidth: viewportData.width,
      viewportOrientation: viewportData.orientation,
      url: window.location.href,
      websitePage:
        window.location.pathname.slice(-1) === '/'
          ? window.location.pathname
          : `${window.location.pathname}/`,
    })
  }

  bindModalTriggers() {
    const $modalTrigger = qsa('.modal-trigger')
    $modalTrigger.forEach(($elem) => {
      $elem.addEventListener('click', this.modalTriggerBind)
    })
    const $webFunnelTrigger = qsa('.web-funnel-trigger')
    $webFunnelTrigger.forEach(($elem) => {
      $elem.addEventListener('click', this.webFunnelTriggerBind)
    })
  }

  webFunnelTriggerOnClick() {
    window.location.href = 'https://app2.earnin.com/questionnaire'
  }

  modalTriggerOnClick() {
    const paid = qs('body').dataset.paid

    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (store.bounds.ww > 900) store.dom.modalSMS.open()
    else {
      if (paid) this.handlePaid(paid, userAgent)
      else {
        var win
        let downloadLink = this.getAdjustDownloadLink()
        if (/android/i.test(userAgent)) {
          win = window.open(downloadLink, '_blank')
          win.focus()
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          win = window.open(downloadLink, '_blank')
          win.focus()
        } else {
          store.dom.modalSMS.open()
        }
      }
    }
  }

  handlePaid(paid, userAgent) {
    if (/android/i.test(userAgent)) this.gtag_report_conversion(true, paid)
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
      this.gtag_report_conversion(false, paid)

    switch (paid) {
      case 'SEARCH_BRAND':
        win = window.open(
          'https://hchm.adj.st?adj_t=g0tzh4z_hid5o3&adj_campaign=Adwords_UA_Web_Brand_CPC',
          '_blank',
        )
        break

      case 'SEARCH_CMP':
        win = window.open(
          'https://hchm.adj.st?adj_t=g0tzh4z_hid5o3&adj_campaign=Adwords_UA_Web_NBCMP_CPC',
          '_blank',
        )
        break

      case 'SEARCH_NB':
        win = window.open(
          'https://hchm.adj.st?adj_t=g0tzh4z_hid5o3&adj_campaign=Adwords_UA_Web_NBFUNC_CPC',
          '_blank',
        )
        break
    }
    win.focus()
  }

  gtag_report_conversion(isAndriod, paid) {
    let id = 'AW-973217545/12oOCOKv8foBEIm-iNAD' //IOS
    if (isAndriod) id = 'AW-973217545/Zec8CMDA8foBEIm-iNAD' //ANDROID

    const callback = function () {}

    gtag('event', 'conversion', {
      send_to: id,
      event_callback: callback,
    })

    return false
  }

  /**
   * Checks if the URL is a non-javascript URL
   * @example https://earnin.com -> true
   * @example javascript:void(0) -> false
   * @param url {string} - URL to check
   * @returns {boolean} - true if the URL is non-javascript, false otherwise
   * @private
   */
  _isNonJavascriptURL(url) {
    return url.startsWith('https') || url.startsWith('http')
  }

  /**
   * Checks if the URL is external to the current window domain
   * @param url {string} - URL to check
   * @returns {boolean} - true if the URL is external, false otherwise
   * @private
   */
  _isExternalURL(url) {
    return this._isNonJavascriptURL(url) ? new URL(url).origin !== window.location.origin : false
  }
}

export default DefaultRenderer
